import { createTheme } from '@material-ui/core/styles';
import { esES } from '@material-ui/core/locale';

let themeSettings = {
  palette: {
    primary: {
      main: '#1a1a1a',
    },
    secondary: {
      main: '#8a8a8a',
    },
  }
}

// try {
//   console.warn('hola');
//   let res = await Http.get(`theme`);
// } catch (error) {
  
// }

export const buildTheme = (color1 = null, color2 = null) => {
  themeSettings.palette.primary.main = !color1 ? themeSettings.palette.primary.main : `#${color1}`;
  themeSettings.palette.secondary.main = !color2 ? themeSettings.palette.secondary.main : `#${color2}`;
  return createTheme(themeSettings, esES);
}

export const theme = createTheme(themeSettings, esES);